import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import get from 'lodash/get'

/**
 * Determines whether the current user has access to the channel
 * @param state The Redux state
 */

const getHasData = (state: State): boolean => state.channel.status.hasData
const getHasError = (state: State): boolean => state.channel.status.hasError
const getAccessForbidden = (state: State): boolean => get(state.channel.status.errorResponse, 'code') === 403

export default createSelector(
  [getHasData, getHasError, getAccessForbidden],
  (hasData, hasError, isAccessDenied) => {

    return (!hasData && !hasError) ? null : hasData || (hasError && !isAccessDenied)

  })
